export default "__VITE_ASSET__CKi5RsCj__"